import { LightningIcon } from '@braskai/icons';
import { Typography, useDeviceType } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

export const PricingHeader = () => {
  const { isMobile } = useDeviceType();
  const { t } = useInterfaceLanguage();

  return (
    <Stack alignItems="center" gap={isMobile ? 8 : 12}>
      <Stack
        sx={{
          backgroundColor: 'primary.50',
          borderRadius: 360,
          color: 'grey.900',
          paddingX: 6,
          paddingY: 2,
        }}
        alignItems="center"
        direction="row"
        gap={4}
      >
        <LightningIcon height={20} width={20} />
        <Typography color="grey.900" variant="body-2-md">
          {t('pricing.title')}
        </Typography>
      </Stack>

      <Stack alignItems="center" gap={isMobile ? 8 : 12}>
        <Typography color="grey.900" sx={{ textAlign: 'center' }} variant={isMobile ? 'title-2-md' : 'title-1-md'}>
          {t('pricing.header.title')}
        </Typography>
        <Typography
          color="grey.900"
          sx={{ maxWidth: 640, textAlign: 'center' }}
          variant={isMobile ? 'body-2-md' : 'body-1-md'}
        >
          {t('pricing.header.description')}
        </Typography>
      </Stack>
    </Stack>
  );
};
